import script from "./SnapVendorTakenAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./SnapVendorTakenAlert.vue?vue&type=script&setup=true&lang=js"

import "./SnapVendorTakenAlert.vue?vue&type=style&index=0&id=6bf5358c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf5358c"]])

export default __exports__